// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__8zA6B","right":"styles_right__lCTS9"};